import { featureFlagClient } from '@trello/feature-flag-client';

export const isStandardOrg = ({
  displayName = '',
  products = [],
}: {
  displayName: string;
  products: number[];
}) => {
  // Overriding check until billing form changes are operational
  // We should be able to emulate checks on any team with
  // displayName starting with "STA "
  const temp_isNuskuFlagEnabled = featureFlagClient.get('nusku.phase-3', false);
  const temp_overrideCheck =
    temp_isNuskuFlagEnabled && /^STA\s/.test(displayName);

  return temp_overrideCheck || [115, 116, 117, 118].includes(products[0]);
};
